import { CheckCircle, Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axiosInstance from "../../../services/axiosInterceptors";
import { palette, theme as colorTheme } from "../../../Convoze.theme";



const primary = colorTheme('palette', 'primary').value;
const pop = colorTheme('palette', 'pop').value;
const positive = colorTheme('palette', 'positive').value;
const neutral = colorTheme('palette', 'neutral').value;
const negative = colorTheme('palette', 'negative').value;



const Register = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [errorMess, setErrorMess] = useState({});
  const [industryType, setIndustryType] = useState([]);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  useEffect(() => {
    getIndustryType();
  }, []);

  const addUser = async (value) => {
    const data = {
      firstName: value.firstName,
      lastName: value.lastName,
      email: value.email,
      password: value.password,
      mobile: value.mobile,
      companyName: value.companyName,
      industryId: value.industryType.value,
      companyWebsite: "godady.com",
    };

    try {
      const res = await axiosInstance.post(apiEndPointsConfig.register, data);
      if (res.data.status.code == 200) {
        localStorage.setItem("token", res.data.data.token);
        localStorage.setItem("userId", res?.data?.data?.user?.userId);
        localStorage.setItem("name", res?.data?.data?.user?.userName);
        navigate("/demo/audio/upload-file");
      }
    } catch (error) {
      setErrorMess(error?.response?.data?.status);
      return error;
    }
  };

  // Formik setup
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      mobile: "",
      companyName: "",
      industryType: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .min(2, "First Name must be at least 2 characters")
        .required("First Name is required"),
      lastName: Yup.string()
        .min(2, "Last Name must be at least 2 characters")
        .required("Last Name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
      mobile: Yup.string()
        .matches(/^\d{10}$/, "Mobile number must be 10 digits")
        .required("Mobile number is required"),
      companyName: Yup.string().required("Company Name is required"),
      industryType: Yup.mixed().required("Industry Type is required"),
    }),
    onSubmit: (values) => {
      addUser(values);
    },
  });

  const getIndustryType = async () => {
    const res = await axiosInstance.get(apiEndPointsConfig.industryType);
    setIndustryType(res?.data?.data);
  };

  return (
    <Grid container>
      <Grid
        item
        md={6}
        xs={12}
        sx={{
          display: {
            xs: "none",
            md: "flex",
          },
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100%",
          bgcolor: "#fcfafa",
          // background:
          // "radial-gradient(50% 50% at 50% 50%, #122647 0%, #090E23 100%)",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: "#1c252e",
              fontWeight: 400,
              mb: 0.6,
              fontFamily: "sans-serif",
            }}
          >
            Welcome to{" "}
            <span style={{ color: positive, fontWeight: 550 }}>
              Speech Analytics
            </span>
          </Typography>
          <Typography
            sx={{
              mb: 4,
              color: "#1c252e",
            }}
          >
            Speech Analytics converts audio to insights, improving customer
            interactions.
          </Typography>
          <img
            style={{
              height: 430,
            }}
            src={
              "https://assets.minimals.cc/public/assets/illustrations/illustration-dashboard.webp"
            }
          />
        </Box>
      </Grid>
      <Grid
        item
        md={6}
        xs={12}
        container
        justifyContent="center"
        alignItems="center"
        style={{
          height: "100vh",
        }}
      >
        <Grid item xs={10} md={8}>
          <Typography variant="h6" sx={{ fontWeight: 550, mb: 1 }}>
            Get started absolutely free
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            Already have an account?
            <Link
              to="/sign-in"
              style={{ color: positive, textDecoration: "none" }}
            >
              &nbsp;Get started
            </Link>
          </Typography>
          <form onSubmit={formik.handleSubmit}>
            <Grid item sx={{ mb: 2, display: "flex", gap: "10px" }}>
              <TextField
                fullWidth
                id="firstName"
                name="firstName"
                placeholder="First Name"
                value={formik.values.firstName}
                onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                error={
                  formik.touched.firstName && Boolean(formik.errors.firstName)
                }
                helperText={formik.touched.firstName && formik.errors.firstName}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    height: "40px",
                  },
                }}
              />
              <TextField
                fullWidth
                id="lastName"
                name="lastName"
                placeholder="Last Name"
                value={formik.values.lastName}
                onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                error={
                  formik.touched.lastName && Boolean(formik.errors.lastName)
                }
                helperText={formik.touched.lastName && formik.errors.lastName}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    height: "40px",
                  },
                }}
              />
            </Grid>
            {/* <Grid item sx={{ mb: 2 }}>
              <TextField
                fullWidth
                id="lastName"
                name="lastName"
                placeholder="Last Name"
                value={formik.values.lastName}
                onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                error={
                  formik.touched.lastName && Boolean(formik.errors.lastName)
                }
                helperText={formik.touched.lastName && formik.errors.lastName}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    height: "40px",
                  },
                }}
              />
            </Grid> */}
            <Grid item sx={{ mb: 2 }}>
              <TextField
                fullWidth
                id="email"
                name="email"
                placeholder="Email address"
                value={formik.values.email}
                onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    height: "40px",
                  },
                }}
              />
            </Grid>
            <Grid item sx={{ mb: 2 }}>
              <TextField
                fullWidth
                id="mobile"
                name="mobile"
                placeholder="Mobile"
                value={formik.values.mobile}
                onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                error={formik.touched.mobile && Boolean(formik.errors.mobile)}
                helperText={formik.touched.mobile && formik.errors.mobile}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    height: "40px",
                  },
                }}
              />
            </Grid>
            <Grid item sx={{ mb: 2, display: "flex", gap: "10px" }}>
              <TextField
                fullWidth
                id="companyName"
                name="companyName"
                placeholder="Company Name"
                value={formik.values.companyName}
                onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                error={
                  formik.touched.companyName &&
                  Boolean(formik.errors.companyName)
                }
                helperText={
                  formik.touched.companyName && formik.errors.companyName
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    height: "40px",
                  },
                }}
              />
              <Autocomplete
                fullWidth
                id="industryType"
                options={industryType}
                getOptionLabel={(e) => e.label || ""}
                value={formik.values.industryType}
                onChange={(event, value) =>
                  formik.setFieldValue("industryType", value)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Industry Type"
                    error={
                      formik.touched.industryType &&
                      Boolean(formik.errors.industryType)
                    }
                    helperText={
                      formik.touched.industryType && formik.errors.industryType
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        height: "40px",
                      },
                    }}
                  />
                )}
                sx={{
                  "& .MuiAutocomplete-inputRoot": {
                    borderRadius: "8px",
                  },
                }}
              />
            </Grid>
            <Grid item sx={{ mb: 2 }}>
              {/* <Autocomplete
                fullWidth
                id="industryType"
                options={industryType}
                getOptionLabel={(e) => e.label || ""}
                value={formik.values.industryType}
                onChange={(event, value) =>
                  formik.setFieldValue("industryType", value)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Industry Type"
                    error={
                      formik.touched.industryType &&
                      Boolean(formik.errors.industryType)
                    }
                    helperText={
                      formik.touched.industryType && formik.errors.industryType
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        height: "40px",
                      },
                    }}
                  />
                )}
                sx={{
                  "& .MuiAutocomplete-inputRoot": {
                    borderRadius: "8px",
                  },
                }}
              /> */}
            </Grid>
            <Grid item sx={{ mb: 2 }}>
              <TextField
                fullWidth
                id="password"
                name="password"
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                value={formik.values.password}
                onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                helperText={formik.touched.password && formik.errors.password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-placeholder="toggle password visibility"
                        onClick={handleClickShowPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    height: "40px",
                  },
                }}
              />
            </Grid>
            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{
                bgcolor: "#1c252e",
                color: "white",
                textTransform: "none",
                fontSize: "1rem",
                mt: 2,
                borderRadius: "12px",
                "&:hover": { bgcolor: primary},
              }}
            >
              Sign up
            </Button>

            {errorMess?.severity === "info" && (
              <Grid
                container
                alignItems="center"
                sx={{
                  bgcolor: negative,
                  borderRadius: 3,
                  p: 1.2,
                  mt: 2,
                }}
              >
                <CheckCircle sx={{ color: "red" }} />
                <Typography sx={{ color: "white", ml: 1 }}>
                  User already exists!
                </Typography>
              </Grid>
            )}
          </form>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Register;
